import { FC, useRef } from 'react';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useDisclosure,
} from '@chakra-ui/react';
import { useUnblockUser } from './use-unblock-user';

export type UserUnblockButtonProps = {
  userId: string;
  userName: string;
  startTimedPolling: () => void;
};

export const UserUnblockButton: FC<UserUnblockButtonProps> = ({
  userId,
  userName,
  startTimedPolling,
}) => {
  const cancelRef = useRef(null);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const { unblockUser, isUnblockLoading } = useUnblockUser();

  const handleUnblock = async () => {
    await unblockUser({
      userId,
      userName,
      startTimedPolling,
    });

    onClose();
  };

  return (
    <>
      <Button
        onClick={onOpen}
        size="sm"
        variant="outline"
        data-testid="user-unblock-button"
      >
        Unblock
      </Button>

      <AlertDialog
        isOpen={isOpen}
        isCentered={true}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent p={2} data-testid="user-unblock-dialog">
            <AlertDialogHeader>Unblock user?</AlertDialogHeader>
            <AlertDialogBody pb={4}>
              {userName} will regain access to the Treaty app.
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button
                ref={cancelRef}
                data-testid="cancel-user-unblock-button"
                onClick={onClose}
              >
                Cancel
              </Button>
              <Button
                ml={3}
                colorScheme="green"
                onClick={handleUnblock}
                isLoading={isUnblockLoading}
                data-testid="confirm-user-unblock-button"
              >
                Unblock
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};
